import React, {useRef} from 'react';
import {Header} from './Components/Header/Header';
import {classes, st} from './SideCart.st.css';
import {Footer} from './Components/Footer/Footer';
import {Body} from './Components/Body/Body';
import './vars.scss';
import {SideCartAppDataHook, SideCartProps} from './SideCart.types';
import {ErrorToast} from '../../../common/components/ErrorToast/ErrorToast';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {Links} from './Components/Links/Links';
import {useControllerProps} from '../../../domain/controllers/ControllerContext';
import {PriceBreakdown} from './Components/PriceBreakdown/PriceBreakdown';

export const SideCart = ({dir}: SideCartProps) => {
  const editorBrand = window?.commonConfig?.brand;
  const isStudioOrEditorXSite = editorBrand === 'editorx' || editorBrand === 'studio';
  const closeButtonRef = useRef<HTMLButtonElement>(null);
  const onRemoveItem = () => closeButtonRef?.current?.focus();
  const {t} = useTranslation();

  const {sideCartNote, sideCartCouponAndNote, shouldRenderEmptyState} = useControllerProps().cartStore;
  const shouldRenderLinks = (sideCartCouponAndNote || sideCartNote) && !shouldRenderEmptyState;
  const shouldRenderPriceBreakdown = sideCartCouponAndNote && !shouldRenderEmptyState;

  return (
    <main
      dir={dir}
      aria-label={t('sideCart.mainFrame.ariaLabel')}
      data-hook={SideCartAppDataHook.root}
      className={st(
        'cartBodyMainOneColumn',
        'sideCart',
        classes.container,
        ...(isStudioOrEditorXSite ? [classes.responsiveEditor] : [])
      )}
      data-wix-side-cart>
      <div className={shouldRenderLinks ? classes.headerAndBody : classes.headerAndBodyOld}>
        <Header closeButtonRef={closeButtonRef} />
        <Body onRemoveItem={onRemoveItem} />
        {shouldRenderLinks && <Links />}
        {shouldRenderPriceBreakdown && <PriceBreakdown />}
      </div>
      <div className={classes.footer}>
        <Footer />
      </div>
      <div className={classes.toastContainer}>
        <ErrorToast />
      </div>
    </main>
  );
};
